import { FormControl, InputGroup } from "react-bootstrap";
import styles from "./../Main.module.scss";

const CurrencyInput = ({ amount, onAmountChange, addToPortfolio }) => {
  return (
    <InputGroup className="mb-3">
      <FormControl
        value={amount}
        onChange={onAmountChange}
        placeholder="Enter the amount to add"
      />
      <InputGroup.Prepend>
        <InputGroup.Text
          className={styles.buttonModal}
          onClick={addToPortfolio}
        >
          +
        </InputGroup.Text>
      </InputGroup.Prepend>
    </InputGroup>
  );
};

export default CurrencyInput;
